module.exports = __webpack_public_path__ + "static/img/TN.a9578446.jpg";